import { AppHelper } from "../appHelper"
import { CommonApp } from "../core/components/commonApp";
import { FullHeightContainer } from "../core/components/FullHeighContainer";
import { Tree, SortableTreeNode, NodeChangeMode } from "../core/components/sortableTree";
import { CommercialDocumentAppProps, CommercialDocumentAppState, SortableTreeNodeCommercial, CommercialDocumentViewModel, CommercialDocumentLineItemViewModel } from "./commercialDocumentsInterfaces";
import { TreeHelper } from "../commercialDocuments/treeHelper";
import { ToolBoxCommand } from "../core/components/sortableTreeSlot";
import { TabStrip } from "../core/components/tabStrip";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Helper } from "../core/util/helper";
import { DialogHelper } from "../core/util/dialogHelper";
import { EntityChooseDialog, SearchType, CloseType, SearchResultData } from "./entityChooseDialog";
import { General } from "../../siteManagement/general";
import { EventType } from "../../siteManagement/eventManager";
import { Config } from "../core/config/config";
import { BaseColumn, DataEntryColumn, DropDownColumn, EditableGrid, field, Schema } from "../core/components/editableGrid/editableGrid";
import { ToolBar, ToolBarCustomButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { booleanEditorHelper, dropDownEditorHelper, getSearch, KendoColumn, numericEditorHelper, textEditorHelper, TreeList } from "./treeList";
import { KendoHtmlEditorCommercial } from "../core/components/kendoHtmlEditorCommercial";
import React from "react";
import ReactDOM from "react-dom";
enum ColumnNames {
    FolderNameOrDeliverableType = "FolderNameOrDeliverableType",
    Article = "Article",
    PrintItem = "PrintItem",
    ProntPrice = "PrintPrice"
}

export default class CommercialDocumentApp extends React.Component<CommercialDocumentAppProps, CommercialDocumentAppState> {
    common = new AppHelper();
    //schaltet den Browsertab-Titel an; wird von common aufgerufen
    setTabTitle = true;
    showAddFolderButton = false;
    private treeRef: Tree;
    private chooseDialogRef: EntityChooseDialog;
    private _gridColumns: BaseColumn[];
    private _schema: Schema;
    private _treeList: TreeList<CommercialDocumentLineItemViewModel>;
    mountedReactComponent: any;

    constructor(props: CommercialDocumentAppProps) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this.showAddFolderButton = false;
        this.state = {
            activeNode: null,
            tree: TreeHelper.sync(this.props.entity),
            flatLineItems: this.props.entity.LineItemsFlatten
        };
        this.setEvents();
    }

    private setEvents = () => {
        General.Events.bind(EventType.Custom, (data: { cmd: string, data: any }) => {
            switch (data.cmd) {
                case "tabStripTabSelected":
                    this.showAddFolderButton = (data.data.index == 1);
                    this.setState({})
                    break;
            }
        });
    }

    addFolderToRoot = () => {
        if (this.common.validate()) {
            DialogHelper.prompt("Folder name", "", 500).then((folderName: string) => {
                if (!Helper.isNullOrEmpty(folderName)) {
                    this.addFolder(folderName)
                }
            })
        }
    }

    downloadWordReport = async () => {
        const result = await HTTPService.post<JsonResultClass<string>>("CommercialDocumentNG/GetReportFile", this.props.entity)
        Helper.openInNewBrowserTab(Config.baseUrl + "CommercialDocumentNG/DownloadFile?file=" + encodeURIComponent(result.Data));
    }

    save = (closeAfterSave: boolean) => {
        if (this.common.validate()) {
            HTTPService.post<JsonResultClass<CommercialDocumentViewModel>>("CommercialDocumentNG/Save", this.props.entity)
                .then(result => {
                    if (result.Code === 0) {
                        if (this.props.entity.IsNew) {
                            General.Functions.HistoryState.replaceState("CommercialDocumentNG/Edit?id=" + this.props.entity.Id);
                        }
                        this.props.entity.IsNew = false;
                        NotificationHelper.showSuccessMessage(result.Message);
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                    this.common.handlePostSave(result.Code === 0, closeAfterSave);
                    this.setState({});
                });
        }
    }

    handleFieldChange = (field: any, value: any, dataItem: any = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);

        if (field.model == "entity.Currency_Foreign_Isguid") {
            if (this.common.validate()) {
                HTTPService.post<JsonResultClass<CommercialDocumentViewModel>>("CommercialDocumentNG/RecalculatePricesAll", { model: this.props.entity })
                    .then((result) => {
                        if (result.Code === 0) {
                            this.refresh(result.Data);

                            let tree = TreeHelper.sync(this.props.entity);
                            let activeNode = null;
                            this.setState({ tree: tree, activeNode: activeNode }, () => {
                                if (this.treeRef !== null) {
                                    this.treeRef.refresh(() => {
                                    });
                                }
                            });
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    });
            }
        }
    }

    private isChangeAllowed = (node: SortableTreeNodeCommercial, parent: SortableTreeNodeCommercial, index: number, nextParent: SortableTreeNodeCommercial, nextIndex: number): Promise<boolean> => {
        return new Promise<boolean>((resolve, reject) => {
            if (!this.props.entity.RecordRight.CanWrite) {
                resolve(false);
            }
            else {
                resolve(true);
            }
        });
    }

    private contentRenderer = (node: SortableTreeNodeCommercial) => {
        return (
            <div className="item item-card">
                <div className="subtitle">
                    {node.Deliverable_Type}
                </div>
                <span className="title">
                    {node.Title}
                </span>
                <div className="detail">
                    {node.Quantity}
                </div>
            </div>);
    }

    private rightContentRenderer = (node: SortableTreeNodeCommercial) => {
        let css: React.CSSProperties = {
            boxShadow: "rgba(0, 0, 0, .14) 0 2px 2px 0, rgba(0, 0, 0, .2) 0 3px 1px -2px, rgba(0, 0, 0, .12) 0 1px 5px 0",
            padding: "10px",
            margin: "5px",
            width: "130px",
            color: node.Invoicing_Type === "NONE" ? "#A9A9A9" : "black",
            fontWeight: "bold",
            fontStyle: "normal"
        }

        let cssSpan: React.CSSProperties = {
            width: "100%", display: "inline-flex", justifyContent: "flex-end"
        };

        return (
            <div style={css}>
                <span style={cssSpan}>{kendo.toString(node.Price, "n2") + " " + node.Currency}</span>
            </div>);
    }

    private handleAfterChange = (node: SortableTreeNodeCommercial, previousParent: SortableTreeNodeCommercial, previousIndex: number, currentParent: SortableTreeNodeCommercial, currentIndex: number, mode: NodeChangeMode) => {

        HTTPService.post<JsonResultClass<CommercialDocumentViewModel>>("CommercialDocumentNG/ModifyTree",
            {
                model: this.props.entity,
                lineItemId: node.Id,
                newParentId: currentParent == null ? null : currentParent.Id,
                newPos: currentIndex,
                changeMode: mode
            })
            .then((result) => {
                if (result.Code === 0) {
                    this.refresh(result.Data);
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }

                let tree = TreeHelper.sync(this.props.entity);

                // ToDo: Hier könnte man bei Copy und Move den vorher aktiven Knoten wieder aktiv machen
                let activeNode = null;

                // Beim Löschen eines Knotens wird anschließend der Parent Knoten ausgewählt
                if (mode == NodeChangeMode.Delete && previousParent.Id !== null)
                    activeNode = TreeHelper.getTreeNode(tree, previousParent.Id)

                this.setState({ tree: tree, activeNode: activeNode }, () => {
                    this.treeRef.refresh(() => {
                        this.treeRef.select(this.state.activeNode);
                    });
                });
            });
    }

    private handleSelect = (node: SortableTreeNodeCommercial) => {
        this.setState({
            activeNode: node.parent != null ? node : null
        });
    }

    private isSelectAllowed = (node: SortableTreeNodeCommercial) => {
        return new Promise<boolean>((resolve, reject) => {
            if (this.props.entity.LineItems.length == 0) { // Bug im tree bei nur einem Knoten wird der vorher gelöschte erste folder zurückgegeben?
                resolve(false);
            }
            else {
                let valid = true;
                let wasChanged = this.common.entityChanged;
                valid = this.common.validate();
                if (wasChanged)
                    this.common.setEntityDirtyState(true);
                resolve(valid);
            }
        });
    }

    private canShowCommand = (type: ToolBoxCommand, node: SortableTreeNodeCommercial, name?: string): boolean => {
        if (!this.props.entity.RecordRight.CanWrite) {
            return false;
        }
        else if (type === ToolBoxCommand.Custom) {
            return node.Deliverable_Type == null;
        }

        return true;
    }

    private afterDelete = (node: SortableTreeNodeCommercial) => {
    }

    private handleEval = (expression: string, additional: any = null) => {
        const localAdditional = $.extend({}, additional, {
            entity: TreeHelper.getLineItemFromTreeNode(this.state.activeNode, this.props.entity),
            entityCommercialDocumentViewModel: this.props.entity
        });
        return this.common.evalAction(expression, localAdditional);
    }

    private handleFieldChangeLineItem = (field: any, value: any, dataItem?: any, afterSetStateCallback?: () => void) => {
        this.handleEval(field.model + "=value", { value: value });
        this.common.handleFieldChange({ model: "entity.LineItems" }, this.props.entity.LineItems);
        if (field.model == "entity.Description") {
            return;
        }
        if (this.common.validate()) {
            var id = this.handleEval("entity.Id");
            const url = field.model == "entity.Invoicing_Type" ? "CommercialDocumentNG/ChangeInvoicingType" : "CommercialDocumentNG/RecalculatePrices";
            HTTPService.post<JsonResultClass<CommercialDocumentViewModel>>(url, { model: this.props.entity, changedLineItem: id })
                .then((result) => {
                    if (result.Code === 0) {
                        this.refresh(result.Data);

                        let tree = TreeHelper.sync(this.props.entity);
                        let activeNode = TreeHelper.getTreeNodeFromLineItem(tree, this.handleEval("entity"));
                        this.setState({ tree: tree, activeNode: activeNode }, () => {
                            this.treeRef.refresh(() => {
                                this.treeRef.select(this.state.activeNode);
                            });
                        });
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
        }
    }

    private refresh = (vm: CommercialDocumentViewModel) => {
        Helper.updateEntity(this.props.entity, vm);
        //this.common.handleFieldChange({ model: "entity.LineItems" }, this.props.entity.LineItems); // nicht mehr benötigt?
    }

    private addFolder = (title: string, parentId: string = null) => {
        HTTPService.post<JsonResultClass<CommercialDocumentViewModel>>("CommercialDocumentNG/AddFolder",
            {
                model: this.props.entity,
                title: title,
                parentId: parentId
            })
            .then((result) => {
                if (result.Code === 0) {
                    //let activeFolderId = null;
                    //if (Helper.hasValue(this.state.activeNode)) {
                    //    activeFolderId = this.state.activeNode.Id;;
                    //}
                    this.refresh(result.Data);
                    let tree = TreeHelper.sync(this.props.entity);
                    let newFolder = TreeHelper.getTreeNode(tree, result.AdditionalData.newId);
                    //let lastActiveFolder = TreeHelper.geTreeNode(tree, activeFolderId);
                    this.setState({ tree: tree, activeNode: newFolder }, this.refreshTree);
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }

    private addArticles = (artNrs: number[], quantity: number, parentId: string) => {
        HTTPService.post<JsonResultClass<CommercialDocumentViewModel>>("CommercialDocumentNG/AddArticles",
            {
                model: this.props.entity,
                artNrs: artNrs,
                parentId: parentId,
                quantity: quantity

            })
            .then((result) => {
                if (result.Code === 0) {
                    let newIds = (result.AdditionalData.newIds as string[]);
                    let activeFolderId = this.state.activeNode.Id;
                    this.refresh(result.Data);
                    let tree = TreeHelper.sync(this.props.entity);
                    let lastActiveFolder = TreeHelper.getTreeNode(tree, activeFolderId);
                    let newArticle = null;
                    if (newIds.length > 0)
                        newArticle = TreeHelper.getTreeNode(tree, newIds[0]);
                    this.setState({ tree: tree, activeNode: (Helper.hasValue(newArticle) ? newArticle : lastActiveFolder) }, this.refreshTree);
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }

    private addExchanges = (ids: number[], parentId: string) => {
        HTTPService.post<JsonResultClass<CommercialDocumentViewModel>>("CommercialDocumentNG/AddExchanges",
            {
                model: this.props.entity,
                nrs: ids,
                parentId: parentId
            })
            .then((result) => {
                if (result.Code === 0) {
                    let newIds = (result.AdditionalData.newIds as string[]);
                    let activeFolderId = this.state.activeNode.Id;
                    this.refresh(result.Data);
                    let tree = TreeHelper.sync(this.props.entity);
                    let lastActiveFolder = TreeHelper.getTreeNode(tree, activeFolderId);
                    let newExchange = null;
                    if (newIds.length > 0)
                        newExchange = TreeHelper.getTreeNode(tree, newIds[0]);
                    this.setState({ tree: tree, activeNode: (Helper.hasValue(newExchange) ? newExchange : lastActiveFolder) }, this.refreshTree);
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }

    private addLabour = (ula: string, grNr: number, parentId: string) => {
        HTTPService.post<JsonResultClass<CommercialDocumentViewModel>>("CommercialDocumentNG/AddLabour",
            {
                model: this.props.entity,
                ula: ula,
                grNr: grNr,
                parentId: parentId
            })
            .then((result) => {
                if (result.Code === 0) {
                    let newId: string = result.AdditionalData.newId;
                    let activeFolderId = this.state.activeNode.Id;
                    this.refresh(result.Data);
                    let tree = TreeHelper.sync(this.props.entity);
                    let lastActiveFolder = TreeHelper.getTreeNode(tree, activeFolderId);
                    let newLabour = null;
                    if (!Helper.isNullOrEmpty(newId))
                        newLabour = TreeHelper.getTreeNode(tree, newId);
                    this.setState({ tree: tree, activeNode: (Helper.hasValue(newLabour) ? newLabour : lastActiveFolder) }, this.refreshTree);
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }

    private refreshTree = () => {
        this.treeRef.refresh(() => {
            this.treeRef.select(this.state.activeNode);
        });
    }

    private addPart = (folder: CommercialDocumentLineItemViewModel) => {
        this.chooseDialogRef.openSearch(SearchType.Parts, (closeType: CloseType, values: SearchResultData[], quantity: number) => {
            if (closeType == CloseType.Ok && values.length > 0) {
                const lst = values.map((value: SearchResultData) => {
                    return value.Key;
                });

                for (const i of lst) {
                    const newItem = { Id: kendo.guid(), "Parent_Line_Item_Id": folder.Id, Deliverable_Type: "PART", Quantity: quantity }
                    this._treeList.appendItem(newItem);
                }
            }
        });
    }

    private handleCustomButtonClick = (id: string) => {
        let deliverableType: string;
        if (id == "EXPENSE_CASH") {
            deliverableType = "CASH";

            this.chooseDialogRef.openSearch(SearchType.CashExpense, (closeType: CloseType, values: SearchResultData[]) => {
                if (closeType == CloseType.Ok && values.length > 0) {
                    const lst = values.map((value: SearchResultData) => {
                        return value.Key;
                    });
                    for (const i of lst) {
                        const dI = this.state.selectedItems[0];
                        const newItem = { Id: kendo.guid(), "Parent_Line_Item_Id": dI["Id"], Deliverable_Type: deliverableType }
                        this._treeList.appendItem(newItem);
                    }
                }
            });
        }
        else if (id == "EXPENSE_LABOUR") {
            deliverableType = "LABOUR";
        }
        else if (id == "EXPENSE_PART") {
            deliverableType = "PART";
            this.addPart(this.state.selectedItems[0]);

        }
        else if (id == "FOLDER") {
            let parentId = this.state.selectedItems && this.state.selectedItems.length == 1 && !this.state.selectedItems[0]["Deliverable_Type"] ? this.state.selectedItems[0]["Id"] : null;
            const newItem = { Id: kendo.guid(), "Parent_Line_Item_Id": parentId }
            this._treeList.appendItem(newItem);
        }

    }

    createInlineGrid = () => {
        const cusBtns: Array<ToolBarCustomButton> = [];

        cusBtns.push({
            caption: "Add folder",
            enabled: this.canAddFolder(),
            iconClass: "fal fa-folder",
            id: "FOLDER"
        });

        cusBtns.push({
            caption: "Add part",
            enabled: this.canAddExpens(),
            iconClass: "fal fa-cog",
            id: "EXPENSE_PART"
        });
        cusBtns.push({
            caption: "Add cash expense",
            enabled: this.canAddExpens(),
            iconClass: "fal fa-money-bill-wave",
            id: "EXPENSE_CASH"
        });

        cusBtns.push({
            caption: "Add cash labour",
            enabled: this.canAddExpens(),
            iconClass: "fal fa-concierge-bell",
            id: "EXPENSE_LABOUR"
        });


        const columns: KendoColumn<CommercialDocumentLineItemViewModel>[] = [
            { title: "", template: (dataItem) => this.renderCell(dataItem, ColumnNames.FolderNameOrDeliverableType), editor: this._folderNameOrExpenseTypeEditor, width: "200px", editable: (dataItem) => this.isCellEditable(dataItem, ColumnNames.FolderNameOrDeliverableType) },
            { title: "Article", template: (dataItem) => this.renderCell(dataItem, ColumnNames.Article), editor: this._articleNumberEditor, editable: (dataItem) => this.isCellEditable(dataItem, ColumnNames.Article) },
            { title: "Print item", template: (dataItem) => this.renderCell(dataItem, ColumnNames.PrintItem), editor: (c, dI) => this.booleanEditorFor("Print_Item", c, dI), editable: (dataItem) => this.isCellEditable(dataItem, ColumnNames.PrintItem) },
            { title: "Print price", template: (dataItem) => this.renderCell(dataItem, ColumnNames.ProntPrice), editor: (c, dI) => this.booleanEditorFor("Print_Price", c, dI) },
            { title: "Quantity", template: this.renderQuantity, editor: (c, dI) => this._numericEditor("Quantity", c, dI) },
            { title: "Invoicing type", template: this.renderDefaultText.bind(this, "Invoicing_Type"), editor: this._getDropDownEditor },
            { title: "Unit_Price_Foreign_Original", template: this.renderDefaultText.bind(this, "Unit_Price_Foreign_Original"), editor: (c, dI) => this._numericEditor("Unit_Price_Foreign_Original", c, dI) },
            { title: "Unit_Price_Foreign", template: this.renderDefaultText.bind(this, "Unit_Price_Foreign"), editor: (c, dI) => this._numericEditor("Unit_Price_Foreign", c, dI) },
            //{ title: "Vat_Identifier_Isguid", template: this._renderDefaultText.bind(this, "Vat_Identifier_Isguid"), editable: (dataItem) => { return dataItem.Deliverable_Type && dataItem.Invoicing_Type != "NONE" } },
            { title: "Unit_Price_Foreign", template: this.renderDefaultText.bind(this, "Unit_Price_Foreign"), editable: (dataItem) => { return dataItem.Deliverable_Type && dataItem.Invoicing_Type != "NONE" }, editor: (c, dI) => this._numericEditor("Unit_Price_Foreign", c, dI) },
            { title: "Discount_Percentage", template: this.renderDefaultText.bind(this, "Discount_Percentage"), editable: (dataItem) => { return dataItem.Deliverable_Type && dataItem.Invoicing_Type != "NONE" }, editor: (c, dI) => this._numericEditor("Discount_Percentage", c, dI) },
            { title: "Discount_On_Total_Amount", template: this.renderDefaultText.bind(this, "Discount_On_Total_Amount"), editable: (dataItem) => { return dataItem.Deliverable_Type && dataItem.Invoicing_Type != "NONE" }, editor: (c, dI) => this._numericEditor("Discount_On_Total_Amount", c, dI) },
            { title: "Unit_Price_Foreign_Modified", template: this.renderDefaultText.bind(this, "Unit_Price_Foreign_Modified"), editable: (dataItem) => { return dataItem.Deliverable_Type && dataItem.Invoicing_Type != "NONE" }, editor: (c, dI) => this._numericEditor("Unit_Price_Foreign_Modified", c, dI) },
            { title: "Unit_Cost_Foreign", template: this.renderDefaultText.bind(this, "Unit_Cost_Foreign"), editable: (dataItem) => { return dataItem.Deliverable_Type && dataItem.Invoicing_Type != "NONE" }, editor: (c, dI) => this._numericEditor("Unit_Cost_Foreign", c, dI) },
            { title: "Unit_Cost", template: this.renderDefaultText.bind(this, "Unit_Cost"), editable: (dataItem) => { return dataItem.Deliverable_Type && dataItem.Invoicing_Type != "NONE" }, editor: (c, dI) => this._numericEditor("Unit_Cost", c, dI) },
            { title: "Unit_Price_Original", template: this.renderDefaultText.bind(this, "Unit_Price_Original"), editable: (dataItem) => { return dataItem.Deliverable_Type && dataItem.Invoicing_Type != "NONE" }, editor: (c, dI) => this._numericEditor("Unit_Price_Original", c, dI) },
            { title: "Unit_Price", template: this.renderDefaultText.bind(this, "Unit_Price"), editable: (dataItem) => { return dataItem.Deliverable_Type && dataItem.Invoicing_Type != "NONE" }, editor: (c, dI) => this._numericEditor("Unit_Price", c, dI) },
            { title: "Unit_Price_Modified", template: this.renderDefaultText.bind(this, "Unit_Price_Modified"), editable: (dataItem) => { return dataItem.Deliverable_Type && dataItem.Invoicing_Type != "NONE" }, editor: (c, dI) => this._numericEditor("Unit_Price_Modified", c, dI) },
            { title: "Description_Long", template: this.renderDefaultText.bind(this, "Unit_Price_Modified"), editable: (dataItem) => { return dataItem.Deliverable_Type && dataItem.Invoicing_Type != "NONE" }, editor: (c, dI) => this._numericEditor("Unit_Price_Modified", c, dI) }
        ]

        const field: any = { model: "entitty.test" };
        return <FullHeightContainer>
            <ToolBar customButtons={cusBtns} handleCustomButtonClick={this.handleCustomButtonClick} />
            <TreeList<CommercialDocumentLineItemViewModel>
                ref={(e) => this._treeList = e}
                idField={{ fieldName: "Id", fieldType: "string" }}
                sortField={{ fieldName: "Psp", fieldType: "string" }}
                parentId={{ fieldName: "Parent_Line_Item_Id", fieldType: "string" }}
                onSelectionChanged={this.handleSelectionChanged}
                data={this.state.flatLineItems}
                columns={columns}
                onKeyDown={this.handleTreeListKeyDown}
            />
        </FullHeightContainer >
    }

    private isCellEditable = (dataItem: CommercialDocumentLineItemViewModel, columnName: ColumnNames): boolean => {
        if (dataItem.IsFolder && columnName != ColumnNames.Article) {
            return true;
        }

        if (columnName == ColumnNames.FolderNameOrDeliverableType) {
            return true;
        }
        if (columnName == ColumnNames.Article) {
            return !!dataItem.Deliverable_Type
        }
        return false;
    }

    private handleTreeListKeyDown = (ctrlKey: boolean, shiftKey: boolean, altKey: boolean, key: string, dataItem: CommercialDocumentLineItemViewModel): void => {
        if (!dataItem) {
            return;
        }
        if (altKey && key == 'a') {
            if (dataItem.IsFolder) {
                const newItem = { Id: kendo.guid(), "Parent_Line_Item_Id": dataItem.Id, Deliverable_Type: null, Quantity: null, IsFolder: false }
                this._treeList.appendItem(newItem);
            }
        }
    }

    private _getDropDownEditor = (container, dataItem: CommercialDocumentLineItemViewModel) => {
        const optionValues = [{ Text: "NONE", Value: "NONE" }, { Text: "ATFIXEDPRICE", Value: "ATFIXEDPRICE" }, { Text: "ATCOST", Value: "ATCOST" }];
        dropDownEditorHelper(container, optionValues, dataItem.Invoicing_Type, "Text", "Value", false, (newValue) => { this.handleFieldChanged("Invoicing_Type", dataItem, newValue) });
    };

    private handleFieldChanged = (column: string, dataItem: CommercialDocumentLineItemViewModel, newValue: any) => {
        dataItem[column as string] = newValue as any;
        this.setState({ flatLineItems: this.state.flatLineItems.slice() });
    };

    private booleanEditorFor = (column: keyof CommercialDocumentLineItemViewModel, container, dataItem: CommercialDocumentLineItemViewModel) => {
        booleanEditorHelper(container, dataItem[column], (newValue) => { this.handleFieldChanged(column, dataItem, newValue) });
    }

    private _numericEditor = (columnName: string, container, dataItem: CommercialDocumentLineItemViewModel) => {
        numericEditorHelper(container, dataItem.Quantity, (newValue) => { this.handleFieldChanged(columnName, dataItem, newValue) });
    }

    private _articleNumberEditor = (container, dataItem: CommercialDocumentLineItemViewModel) => {

        const titleColumnChanged = (newValue) => {
            if (!dataItem.Deliverable_Type) {
                dataItem.Title = newValue;
            }
            else {
                if (typeof newValue == "object") {
                    dataItem.Deliverable_Id = newValue.artikelnummer
                    dataItem.Title = newValue.bezeichnung;
                    dataItem.Unit_Price_Foreign_Original = (Math.round(Math.random() * 1000 * 100) / 100);
                }
                else {
                    dataItem.Deliverable_Id = newValue;
                }
            }

            this.setState({ flatLineItems: this.state.flatLineItems.slice() });
        };

        const search = getSearch(dataItem.Deliverable_Id, titleColumnChanged);

        const div = $("<div></div>");
        div.appendTo(container);

        if (this.mountedReactComponent) {
            ReactDOM.unmountComponentAtNode(this.mountedReactComponent);
        }
        this.mountedReactComponent = div[0];

        ReactDOM.render(search, this.mountedReactComponent);
    }

    private _folderNameOrExpenseTypeEditor = (container, dataItem: CommercialDocumentLineItemViewModel) => {

        const titleColumnChanged = (newValue) => {
            if (!dataItem.Deliverable_Type) {
                dataItem.Title = newValue;
            }
            else {
                if (typeof newValue == "object") {
                    dataItem.Deliverable_Id = newValue.artikelnummer
                    dataItem.Title = newValue.bezeichnung;
                    dataItem.Unit_Price_Foreign_Original = (Math.round(Math.random() * 1000 * 100) / 100);
                }
                else {
                    dataItem.Deliverable_Id = newValue;
                }
            }

            this.setState({ flatLineItems: this.state.flatLineItems.slice() });
        };

        if (!dataItem.IsFolder) {
            const optionValues = [{ Text: "PART", Value: "PART" }, { Text: "EXPENSE", Value: "EXPENSE" }, { Text: "LABOUR", Value: "LABOUR" }];
            dropDownEditorHelper(container, optionValues, dataItem.Deliverable_Type, "Text", "Value", true, (newValue) => { this.handleFieldChanged("Deliverable_Type", dataItem, newValue) });
        }
        else {
            textEditorHelper(container, dataItem.Title, titleColumnChanged);
        }
    }

    _renderReactComponentToString = (reactComponent: JSX.Element): string => {
        const reactString = window["ReactDOMServer"].renderToStaticMarkup(reactComponent);
        return reactString;
    }

    renderDefaultText = (column: string, dataItem: CommercialDocumentLineItemViewModel): string => {
        const template = <div className="templateRoot" style={{ pointerEvents: "none", display: "inline-block", fontWeight: !dataItem.Deliverable_Type ? "bold" : "normal" }}>{dataItem[column]}</div>;
        const reactString = this._renderReactComponentToString(template);
        return reactString;
    }

    renderQuantity = (dataItem: CommercialDocumentLineItemViewModel): string => {
        const template = <div className="templateRoot" style={{ pointerEvents: "none", display: "inline-block", fontWeight: !dataItem.Deliverable_Type ? "bold" : "normal" }}>{dataItem.Quantity} {dataItem.Unit_Of_Measure}</div>;
        const reactString = this._renderReactComponentToString(template);
        return reactString;
    }

    createCheckBoxRenderer = (value: boolean): string => {
        let htmlString = "-";
        if (value === true) {
            htmlString = '<i class="fal fa-check" aria-hidden="true"></i>';
        } else {
            htmlString = '<i class="fal fa-square" aria-hidden="true"></i>';
        }

        return "<div>" + htmlString + "</div>";
    }

    renderCell = (dataItem: CommercialDocumentLineItemViewModel, columnName: ColumnNames) => {
        const isEditable = this.isCellEditable(dataItem, columnName);

        if (!isEditable) {
            return createEmptyCell();
        }

        if (columnName == ColumnNames.FolderNameOrDeliverableType) {
            return this.renderFolderNameOrExpenseType(dataItem);
        } else if (columnName == ColumnNames.PrintItem) {
            return this.createCheckBoxRenderer(dataItem.Print_Item);
        }
        else if (columnName == ColumnNames.ProntPrice) {
            return this.createCheckBoxRenderer(dataItem.Print_Price);
        }

        let template;
        if (!dataItem.Deliverable_Type) {
            return createEmptyCell();
        }

        if (!dataItem.Deliverable_Type) {
            return "";
        }
        template = <div style={{ display: "inline-block" }}>
            <div className="templateRoot" style={{ pointerEvents: "none", display: "inline-block", fontWeight: !dataItem.Deliverable_Type ? "bold" : "normal" }}>
                {dataItem.Deliverable_Id}
            </div>
        </div>;
        const reactString = window["ReactDOMServer"].renderToStaticMarkup(template);
        return reactString;
    }

    renderFolderNameOrExpenseType = (dataItem: CommercialDocumentLineItemViewModel) => {
        const reactString = window["ReactDOMServer"].renderToStaticMarkup(<Cell value={dataItem.IsFolder ? dataItem.Title : dataItem.Deliverable_Type} renderTextBold={!dataItem.Deliverable_Type}></Cell>);
        return reactString;
    }

    canAddExpens = () => {
        return this.state.selectedItems && this.state.selectedItems.length == 1 && !this.state.selectedItems[0].Deliverable_Type;
    }

    canAddFolder = () => {
        return !this.state.selectedItems || this.state.selectedItems.length == 0 || this.state.selectedItems.length == 1 && !this.state.selectedItems[0].Deliverable_Type;
    }

    handleSelectionChanged = (selectedItems: CommercialDocumentLineItemViewModel[]) => {
        this.setState({ selectedItems: selectedItems });
    }

    createLineItems = () => {
        let tabstrip = null;
        if (this.state.activeNode != null) {
            let entity = TreeHelper.getLineItemFromTreeNode(this.state.activeNode, this.props.entity);
            if (Helper.hasValue(entity)) { // Fall abfangen, dass entity nicht exisiert wenn z.B. gelöscht wurde und im Baum noch kurze Zeit existiert
                tabstrip =
                    <TabStrip metadata={this.props.metadataLineItem} entity={entity}
                        dataSources={{}} context={this.props.context} horizontal={true}
                        onChange={this.handleFieldChangeLineItem} handleEval={this.handleEval}
                        onDataLoaded={this.common.handleDataLoaded} commandManager={this.common.commandManager} >
                    </TabStrip>;
            }
        }

        return (
            <FullHeightContainer classes="flex-container--row">
                <div className="tree" style={{ width: "50%", minWidth: 200, height: "100%", display: "flex", flexDirection: "column", overflowY: "auto" }}>
                    <Tree
                        ref={(r) => this.treeRef = r}
                        tree={this.state.tree}
                        isChangeAllowed={this.isChangeAllowed}
                        noderRenderer={this.contentRenderer}
                        rightContentRenderer={this.rightContentRenderer}
                        afterChange={this.handleAfterChange}
                        afterSelect={this.handleSelect}
                        canBeSelected={this.isSelectAllowed}
                        nodeParenProperty="parent"
                        afterDelete={this.afterDelete}
                        commands={{
                            canShow: (type: ToolBoxCommand, node: SortableTreeNode, name?: string) => {
                                return this.canShowCommand(type, node as SortableTreeNodeCommercial, name);
                            },
                            custom: [
                                {
                                    iconName: "cog",
                                    name: "addArticle",
                                    hint: "***Add part***",
                                    onClick: (cmd, node) => {
                                        if (this.common.validate()) {
                                            this.chooseDialogRef.openSearch(SearchType.Parts, (closeType: CloseType, values: SearchResultData[], quantity: number) => {
                                                if (closeType == CloseType.Ok && values.length > 0) {
                                                    let lst = values.map((value: SearchResultData) => {
                                                        return value.Key;
                                                    });
                                                    this.addArticles(lst, quantity, this.state.activeNode == null ? null : this.state.activeNode.Id);
                                                }
                                            });
                                        }
                                    }

                                },
                                {
                                    iconName: "money-bill-wave",
                                    name: "addCashExpense",
                                    hint: "***Add cash expense***",
                                    onClick: () => {
                                        if (this.common.validate()) {
                                            if (this.common.validate()) {
                                                this.chooseDialogRef.openSearch(SearchType.CashExpense, (closeType: CloseType, values: SearchResultData[]) => {
                                                    if (closeType == CloseType.Ok && values.length > 0) {
                                                        let lst = values.map((value: SearchResultData) => {
                                                            return value.Key;
                                                        });
                                                        this.addExchanges(lst, this.state.activeNode == null ? null : this.state.activeNode.Id);
                                                    }
                                                });
                                            }
                                        }
                                    }
                                },
                                {
                                    iconName: "concierge-bell",
                                    name: "addLabour",
                                    hint: "***Add labour***",
                                    onClick: () => {
                                        if (this.common.validate()) {
                                            this.chooseDialogRef.openSearch(SearchType.Labour, (closeType: CloseType, values: SearchResultData[], grNr: number) => {
                                                if (closeType == CloseType.Ok && values.length > 0) {
                                                    this.addLabour(values[0].Key, grNr, this.state.activeNode == null ? null : this.state.activeNode.Id);
                                                }
                                            });
                                        }
                                    }
                                },
                                {
                                    iconName: "folder-plus",
                                    name: "addFolder",
                                    hint: "***Add folder***",
                                    onClick: () => {
                                        if (this.common.validate()) {
                                            DialogHelper.prompt("***Folder name***", "", 500).then((folderName: string) => {
                                                if (!Helper.isNullOrEmpty(folderName)) {
                                                    this.addFolder(folderName, this.state.activeNode == null ? null : this.state.activeNode.Id)
                                                }
                                            })
                                        }
                                    }

                                }
                            ]
                        }}
                    />
                </div>
                <div style={{ width: "50%", minWidth: 200, height: "100%", display: "flex", flexDirection: "column", overflowY: "auto" }}>
                    {tabstrip}
                </div>
            </FullHeightContainer>
        );
    }

    createLineItemsGrid = () => {
        return (
            <div></div>
        );
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return (
            <>
                <CommonApp {...props} />
                <EntityChooseDialog ref={(ref) => { this.chooseDialogRef = ref; }} />
            </>
        );
    }
};

interface CellProps {
    renderTextBold?: boolean
    value?: string
    isMandatory?: boolean
    canEdit?: boolean
    showValue?: boolean
}

class Cell extends React.Component<CellProps, any> {

    render() {
        const cell = <div style={{ display: "inline-block" }}>
            {/*{icon}*/}
            <div className="templateRoot" style={{ pointerEvents: "none", display: "inline-block", fontWeight: this.props.renderTextBold ? "bold" : "normal" }}>
                {this.props.value}
            </div>
        </div>
        return cell;
    }
}

const emptyCell = '<div style="background-color:lightgray" }}> &nbsp</div>';
function createEmptyCell() {
    return emptyCell;
}